export default __webpack_public_path__ + "static/sfyimby-e70239d63df3b746a605aacca990a26c.png";